import React, { useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Whisper, Popover } from "rsuite";
import { FaRegEdit, FaRegEye,FaPlusCircle } from "react-icons/fa";

const ActionCellStock = ({ data, onView, onEdit, onAddNew }) => {

  const navigate = useNavigate();
  const location = useLocation();
  const whisperRef = useRef(null); // ✅ ref to control the popover

  const handleViewClick = () => {
    if (onView) onView(data); // open Offcanvas
    if (whisperRef.current) whisperRef.current.close(); // ✅ close popover directly
  };

  const renderPopover = (
    <Popover arrow={false} full className="p-2 rounded-md w-48">
      <div className="px-3 pt-2 pb-1 text-sm font-bold text-gray-800">
        Actions
      </div>

    <div
  onClick={() => {
    if (onEdit) onEdit(data);
    if (whisperRef.current) whisperRef.current.close();
  }}
  className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md"
>
  <FaRegEdit className="text-sm text-[#55c999]" />
  <span>Edit</span>
</div>


      <div
        onClick={handleViewClick}
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md"
      >
        <FaRegEye className="text-sm text-[#383838]" />
        <span>View</span>
      </div>
       <div
        onClick={() => {
    if (onAddNew) onAddNew();
    if (whisperRef.current) whisperRef.current.close();
  }}
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md"
      >    <FaPlusCircle className="text-sm text-[#22c55e]" /> 
        <span>Create New Batch</span>
      </div>
    </Popover>
  );

  return (
    <Whisper
      ref={whisperRef} // ✅ attach ref
      placement="bottomEnd"
      trigger="click"
      speaker={renderPopover}
    >
      <button
        className="inline-flex items-center justify-center w-10 h-10 rounded-md hover:bg-gray-100"
        title="More actions"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="lucide lucide-ellipsis h-4 w-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
        >
          <circle cx="12" cy="12" r="1" />
          <circle cx="19" cy="12" r="1" />
          <circle cx="5" cy="12" r="1" />
        </svg>
      </button>
    </Whisper>
  );
};

export default ActionCellStock;
